import { Component, Input, SimpleChanges } from "@angular/core";
import { PolicyHeaderComponent } from "../policy-header/policy-header.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-aul-001-24",
  standalone: true,
  imports: [PolicyHeaderComponent, CommonModule],
  templateUrl: "./aul-001-24.component.html",
  styleUrl: "./aul-001-24.component.scss",
})
export class Aul00124Component {
  @Input() policyDetails!: any;
  surplusFeeTotal = 0;
  private fullPolicyData: any = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.fullPolicyData = changes["policyDetails"].currentValue;
      this.policyDetails = this.fullPolicyData?.aul_001_24;
      const bislFeeDetails = this.policyDetails?.bislFeeDetails || [];
      
      this.surplusFeeTotal = Array.isArray(bislFeeDetails)
        ? bislFeeDetails.reduce(
            (sum: number, detail: any) =>
              sum + (detail?.feeAmount !== undefined && detail?.feeAmount !== null
                ? Number(detail.feeAmount)
                : 0),
            0
          )
        : 0;
    }
  }

  getSurplusLinesState(): string {
    return this.fullPolicyData?.aul_000_24?.state || '';
  }

  isNewJerseyPolicy(): boolean {
    const stateId = this.fullPolicyData?.aul_000_24?.stateId;
    const state = this.fullPolicyData?.aul_000_24?.state;
    return stateId === 30 || state?.toLowerCase() === 'new jersey';
  }

  getNJTN(): string {
    if (!this.isNewJerseyPolicy()) {
      return '';
    }
    const aul00024 = this.fullPolicyData?.aul_000_24;
    if (!aul00024) {
      return '';
    }
    const slaNumber = aul00024.slaNumber || '';
    const njtnYear = aul00024.njtnYear;
    const njtn = aul00024.njtn || '';
    
    // Format: slaNumber-njtnYear-njtn (e.g., "78678-26-45555")
    // njtnYear can be a number (26) or string, convert to string for display
    if (slaNumber && njtnYear !== null && njtnYear !== undefined && njtn) {
      const yearStr = String(njtnYear);
      return `${slaNumber}-${yearStr}-${njtn}`;
    }
    return '';
  }
}
